import { T }                                           from 'defa-object';
import { VuePillBarComponent, VuePillBarPlugin }       from 'scripts/plugins/vue-pill-bar';
import { VueRadioStripComponent, VueRadioStripPlugin } from 'scripts/plugins/vue-radio-strip';

import VueBackbone                                     from 'vue-backbone/dist/vue-backbone';
import { DefaSelectComponentPlugin }                   from 'vue/defa-select-dropdown';
import { DefaSliderComponent, SliderPlugin }           from 'vue/defa-slider';
import { VueTimePickerComponent, VueTimePickerPlugin } from 'vue/defa-timepicker';
import { DefaSwitchComponent }                         from 'vue/defa-switch';
import { WeatherComponentPlugin }                      from 'vue/defa-weather';
import Vue                                             from 'vue/dist/vue.esm';

Vue.mixin( {
	methods: {
		tc: ( ...args ) => T.tc( ...args )
	}
} );

Vue.filter( 'timeOnly', function ( value ) {
	let v;
	switch ( value.constructor.name ) {
		case 'Date':
			v = value;
			break;
		case 'Number':
		case 'String':
			v = new Date( value );
			break;
	}
	return v.format( 'HH:MM' );
});

Vue.filter('round', function(value) {
	return Math.round(value);
});
Vue.filter('formatDateTime', function(value) {
	return value.format( 'yyyy-mm-dd HH:MM');
});
Vue.filter('formatLongDateTime', function(value) {
	return value.format(T.dateFormatLong);
});


Vue.use( VueBackbone );
Vue.use( DefaSelectComponentPlugin );
Vue.use( VueRadioStripPlugin );
Vue.use( VuePillBarPlugin );
Vue.use( WeatherComponentPlugin );
Vue.use( SliderPlugin );
Vue.use(VueTimePickerPlugin);


export const VueRadioStrip     = Vue.extend( VueRadioStripComponent );
export const VuePillBar    = Vue.extend( VuePillBarComponent );
export const VueMaterialSlider = Vue.extend( DefaSliderComponent );
export const VueSwitch         = Vue.extend( DefaSwitchComponent );
export const VueTimePicker = Vue.extend(VueTimePickerComponent);

export { Vue };
